import React from 'react';
import { ZapIcon } from 'lucide-react';
import { SectionReveal } from '../SectionReveal';
import { CountdownTimer } from '../CountdownTimer';
export function CountdownSection() {
  return <section className="w-full" style={{
    background: 'linear-gradient(180deg, #FF6B00 0%, #7a3300 45%, #0A0A0A 100%)'
  }} aria-labelledby="countdown-heading" data-id="element-67">
      <SectionReveal className="mx-auto max-w-4xl px-5 py-16 text-center sm:py-20" data-id="element-68">
        <p className="flex items-center justify-center gap-2 font-heading text-sm font-bold uppercase tracking-widest text-white" data-id="element-69">
          <ZapIcon className="h-5 w-5" data-id="element-70" /> Atención: este precio cierra en…
        </p>
        <h2 id="countdown-heading" className="sr-only" data-id="element-71">
          Cuenta regresiva de la oferta
        </h2>
        <div className="mt-8" data-id="element-72">
          <CountdownTimer size="lg" data-id="element-73" />
        </div>
        <p className="mx-auto mt-8 max-w-md text-base font-medium text-white/90" data-id="element-74">
          Cuando llegue a cero, el precio sube. Sin excepciones.
        </p>
      </SectionReveal>
    </section>;
}